import { combineReducers } from 'redux';
import { IntlReducer as Intl } from 'react-redux-multilingual';
import HomeReducer from '../containers/Home/HomeReducer';
import ApartmentViewReducer from '../containers/ApartmentView/ApartmentViewReducer';
import LoaderReducer from '../components/Loader/LoaderReducer';
import UserReducer from './UserReducer/UserReducer';
import ReservationReducer from './ReservationsReducer/ReservationsReducer';
import BookingHistory from '../containers/BookingHistory/BookingHistoryReducer';
import CityViewReducer from '../containers/CityView/CityViewReducer';

export default combineReducers({
    home: HomeReducer,
    apartmentView: ApartmentViewReducer,
    loading: LoaderReducer,
    user: UserReducer,
    Intl,
    reservation: ReservationReducer,
    bookingHistory: BookingHistory,
    cityView: CityViewReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js